export default __webpack_public_path__ + "static/media/0x853ee4b2a13f8a742d64c8f088be7ba2131f670d.06475712.svg";